export default __webpack_public_path__ + "static/media/brokers.105971c5.svg";